import { render } from "./Store.vue?vue&type=template&id=4fbcf4c4"
import script from "./Store.vue?vue&type=script&lang=js"
export * from "./Store.vue?vue&type=script&lang=js"

import "./Store.vue?vue&type=style&index=0&id=4fbcf4c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__